import { Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FormValidation } from 'src/app/services/FormValidation';
import { JobModel, profileinput } from 'src/app/services/jobModel';
import { StreamService } from 'src/app/services/stream.service';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { BENEFITS_KEY, ExpiryModel, PayAsYouGoModel, PricePlanService } from '../priceplanService';
import { SearchData } from './../../../services/searchData';
import { environment } from 'src/environments/environment';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from 'src/app/icons/icon-provider';
@Component({
  selector: 'app-model-price',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule,
    NgIconComponent,
    BsDropdownModule
  ],
  providers: [provideIcons(APP_ICONS)],
  templateUrl: './model-price.component.html',
  styleUrls: ['./model-price.component.scss'],
  inputs: ["ModelContent", "content", "modalName", "upgradeDetails", "currentdate", "featureddate", "availablecredits", "actualcredits", "utilizedcredits", "promotional", "alertdate", "availablePostingsSlots"]
})
export class ModelPriceComponent implements OnInit, OnDestroy {
  // Set by PricePlanService.expiredPopup() via initialState. Fired from
  // ngOnDestroy so the singleton `expiredPopupOpen` guard is cleared EXACTLY
  // when THIS popup is torn down — never on an unrelated modal's close.
  onExhaustPopupDestroyed: (() => void) | undefined;
  onUpgradePlanClick?: () => void;
  streamRes: any = null;
  ENVIRONMENT = environment;
  clickEventsubscription: Subscription;

  businessRole : any;
  userType = localStorage.getItem('userType') || '';

  // `hostRef` is THIS popup's own container. BsModalService._showModal() provides
  // a BsModalRef in every modal's injector, so injecting it gives us the exact
  // container wrapping ModelPriceComponent. @Optional() because the component is
  // only ever created through modalService.show().
  constructor(private modalService: BsModalService, private route: Router, private router : Router,
    private pricePlan: PricePlanService, private stremService: StreamService,  private api: ApiService, private searchData: SearchData, private util: UtilService, private formBuilder: UntypedFormBuilder,
    public formValidation: FormValidation,
    @Optional() private hostRef: BsModalRef) {
    this.clickEventsubscription = this.stremService.getstreamResponse().subscribe((res) => {
      this.streamRes = res;
    });

    this.businessRole = localStorage.getItem('businessRole');
  }

  // Single teardown path for every exit (Close, ×, routing away).
  //
  // Replaces `this.modalService.hide(1)`. hide(level) resolves loaders[level-1],
  // so hide(1) always targets the OLDEST open modal — only this popup's host
  // when nothing else is open. Opened over the Job/Candidate Edit modal it
  // closed the Edit form instead and orphaned this popup's own container,
  // leaving stale <modal-container> nodes and drifting modalsCount.
  private dismiss(): void {
    this.closeThisPopup();
  }

  /**
   * Closes THIS popup and nothing else.
   *
   * Every close path used `modalService.hide(1)`. In ngx-bootstrap 5.6 that hides
   * `loaders[0]` - the OLDEST open modal - not the caller. Whenever this popup was
   * not the oldest (it opens on top of the Invite / Resume Request / Apply modals,
   * and stale loaders from earlier modals can sit at the front too), hide(1)
   * destroyed a DIFFERENT modal. This component was never destroyed, so its
   * ngOnDestroy never ran and PricePlanService.expiredPopupOpen stayed true.
   *
   * That flag is on a root singleton and gates every exhausted-slot popup, so from
   * then on Invite, Apply, Chat, Download Resume and Resume Request all returned
   * silently at the guard: the popup showed once, and every later click did
   * nothing until a page refresh.
   *
   * hostRef.hide() goes through ModalContainerComponent.hide(), which calls
   * bsModalService.hide(this.level) with THIS container's own level, so it always
   * tears down this popup and ngOnDestroy always resets the guard.
   */
  private closeThisPopup(): void {
    if (this.hostRef) {
      this.hostRef.hide();
    } else {
      // Only reachable if the component was created outside modalService.show().
      this.modalService.hide(1);
    }
  }

  /**
   * For the actions that LEAVE the page (Upgrade Plan, Go to plan quota, slot
   * allocation, contacts). Closes every open modal, not just this one.
   *
   * closeThisPopup() is right for Close / Cancel, where the user stays put and any
   * form this popup was opened over should survive. But BsModals live on <body>
   * and are not torn down by a route change, and nothing in this app clears them on
   * navigation. So when this popup sits on top of another modal - the Job /
   * Candidate Edit form when posting slots run out - closing only this one would
   * leave that form floating over the next page.
   *
   * The old hide(1) call was wrong the other way round here: it closed the form
   * underneath and left THIS popup orphaned over the new page, with its guard stuck.
   *
   * hide(1) once per open modal: each call queues removal of whatever is oldest at
   * that moment, so N calls clear the stack in order. This popup is part of that
   * stack, so it is still destroyed and its ngOnDestroy still resets the guard.
   */
  private closeAllForNavigation(): void {
    const open = this.modalService.getModalsCount();
    if (open === 0) {
      this.closeThisPopup();
      return;
    }
    for (let i = 0; i < open; i++) {
      this.modalService.hide(1);
    }
  }
  FormData: any;
  modalRef: BsModalRef | undefined;
  yearmonth: boolean = false;
  profileDetailResponse: any;
  messageShow = false;
  submitted = false;
  content: BENEFITS_KEY | undefined;
  ModelContent: PayAsYouGoModel | ExpiryModel | any;
  modalName: "UPGRADE" | "PAY" | "LIMIT" | undefined;
  upgradeDetails: JobModel | undefined;
  currentdate: profileinput | undefined;
  featureddate: profileinput | undefined;
  alertdate: profileinput | undefined
  availablecredits: profileinput | undefined;
  promotional: profileinput | undefined;
  actualcredits: profileinput | undefined;
  utilizedcredits: profileinput | undefined;
  CreditConsumePoints: String | undefined;
  PlanConsumePoints: String | undefined;
  @Input() passValues: any;
  modelOpened: any;
  points: any = [];

  availablePostingsSlot:any;

  // Interactive options for the Jobs / Candidate Slots LIMIT popup.
  // null = all accordions collapsed (clicking an open header toggles it shut).
  selectedSlotOption: 'INACTIVATE' | 'ASSIGN' | 'UPGRADE' | null = 'INACTIVATE';
  slotSubType: 'JOBS' | 'CANDIDATES' = 'JOBS';
  activeJobs: any[] = [];
  activeCandidates: any[] = [];
  loadingActiveList = false;
  activeListLoaded = { JOBS: false, CANDIDATES: false };

  dynamicMessage: string;
  dynamicTitle: string;
  @Output() selectedJob: EventEmitter<any> = new EventEmitter()
  @Output() jobReload = new EventEmitter<any>();
  @Output() candidateReload = new EventEmitter<any>()
  selectedValue: String;
  clearSelectedValues: boolean = false;
  selectedDay: number;

  upgradeForm: UntypedFormGroup;
  MemberShipType = localStorage.getItem("MemberShipType");
  @ViewChild("modalTemplate", { static: true }) modalPriceTemplate: TemplateRef<any>;
  @ViewChild("upgradejob", { static: true }) upgradePriceTemplate: TemplateRef<any>;
  @ViewChild("limitReached", { static: true }) limmitReachedTemplate: TemplateRef<any>;

  backdropConfig: ModalOptions = {
    backdrop: "static",
    keyboard: false,
    // scroll
  };
  async ngOnInit() {
    this.CreditConsumePoints = this.content ? await this.getPoints(this.content) : undefined;
    this.selectedValue = 'redeemsumocredits';

    // Single-modal render: the selected template is now shown INLINE in this
    // component's own modal container (see model-price.component.html's
    // <ng-container *ngTemplateOutlet>) instead of opening a SECOND modal here.
    // That removes the host+inner two-container stack that made the popup look
    // like it closed twice. ngOnInit only prepares data now.
    switch (this.modalName) {
      case "UPGRADE":
        if (this.ModelContent && this.ModelContent.headerName !== undefined) {
          this.upgradefunction();
          this.upgradeForm.get('upgradefor').patchValue(this.ModelContent.headerName);
        }
        break;

      case "LIMIT":
        if (this.ModelContent && this.ModelContent.headerName === 'Jobs / Candidate Slots ') {
          // Start on whichever entity this role can manage (jobs preferred when
          // the role handles both).
          this.slotSubType = this.canDeactivateJobs ? 'JOBS' : 'CANDIDATES';
          if (this.slotSubType === 'JOBS') {
            this.loadActiveJobs();
          } else {
            this.loadActiveCandidates();
          }
          // Deactivate section is always expanded; on Free plan also open the
          // Upgrade accordion by default (it's the second option shown).
          this.selectedSlotOption = this.isFreePlan ? 'UPGRADE' : null;
        }
        break;

      default:
        break;
    }
  }

  ngOnDestroy(): void {
    // Clear the singleton exhaust-popup guard the moment THIS popup is gone, so
    // the next legitimate slot-exhausted event can show it again. Keyed to this
    // component's lifecycle — not the global modalService.onHidden — so an
    // unrelated modal closing (e.g. the Edit form underneath) can no longer
    // reset the guard early and let a duplicate popup stack.
    if (this.onExhaustPopupDestroyed) {
      this.onExhaustPopupDestroyed();
    }
    if (this.clickEventsubscription) {
      this.clickEventsubscription.unsubscribe();
    }
  }

  routetoplanpage() {
    if (this.onUpgradePlanClick) {
      this.onUpgradePlanClick();
    }
    this.route.navigate(['/plan-quota']);
    this.closeAllForNavigation();
  }

  get isSuperAdmin(): boolean {
    return this.businessRole === 'SUPERADMIN';
  }

  // Free plan is an individual plan with no SuperAdmin / slot-allocation flow,
  // so the "Assign more slots" option is hidden for them in the slots LIMIT
  // popup (they get Deactivate + Upgrade only). See model-price.component.html.
  get isFreePlan(): boolean {
    return this.MemberShipType === 'Free';
  }

  // Which entities this role can deactivate in the slots-limit popup. Mirrors
  // the job/candidate capability split in langding-page-nav-bar (isJob* /
  // isCandidate* getters, lines 690/694):
  //   RECRUITER                                          → jobs only
  //   BENCH_RECRUITER / JOB_SEEKER                       → candidates only
  //   FREELANCE_RECRUITER / MANAGEMENT_TALENT_ACQUISITION → both
  get canDeactivateJobs(): boolean {
    return this.userType === 'RECRUITER'
        || this.userType === 'FREELANCE_RECRUITER'
        || this.userType === 'MANAGEMENT_TALENT_ACQUISITION';
  }
  get canDeactivateCandidates(): boolean {
    return this.userType === 'BENCH_RECRUITER'
        || this.userType === 'FREELANCE_RECRUITER'
        || this.userType === 'MANAGEMENT_TALENT_ACQUISITION'
        || this.userType === 'JOB_SEEKER';
  }
  // The Jobs/Candidates radio only appears when the role handles BOTH.
  get showSlotSubTypeToggle(): boolean {
    return this.canDeactivateJobs && this.canDeactivateCandidates;
  }
  // Deactivate-section header text, scoped to what the role can act on.
  get deactivateSectionTitle(): string {
    if (this.canDeactivateJobs && this.canDeactivateCandidates) return 'Deactivate Job / Candidate';
    return this.canDeactivateJobs ? 'Deactivate Job' : 'Deactivate Candidate';
  }
  // One-line instruction under the header, matching the entity scope.
  get deactivateInstruction(): string {
    if (this.canDeactivateJobs && this.canDeactivateCandidates) {
      return 'Deactivate a job/candidate below to free up a slot and continue posting.';
    }
    return this.canDeactivateJobs
      ? 'Deactivate a job below to free up a slot and continue posting jobs.'
      : 'Deactivate a candidate below to free up a slot and continue posting candidates.';
  }
  // A slot must be free before an inactive item can be switched back on.
  get hasAvailableSlot(): boolean {
    return Number(this.availablecredits) > 0;
  }

  // --- Row status toggle helpers -------------------------------------------
  isJobActive(job: any): boolean {
    return (job?.status || '').toString().toUpperCase() === 'ACTIVE';
  }
  isCandidateActive(candidate: any): boolean {
    return (candidate?.status || '').toString().toUpperCase() === 'ACTIVE';
  }
  // Status-specific toggle labels (point 5): jobs Active/On Hold,
  // candidates Available/Unavailable.
  jobToggleLabel(job: any): string {
    return this.isJobActive(job) ? 'Active' : 'On Hold';
  }
  candidateToggleLabel(candidate: any): string {
    return this.isCandidateActive(candidate) ? 'Available' : 'Unavailable';
  }
  onJobToggle(job: any): void {
    const activating = !this.isJobActive(job);
    // Guard mirrors the disabled state in the template — can't reactivate with
    // no free slot.
    if (activating && !this.hasAvailableSlot) return;
    this.onJobStatusChange(job, activating ? 'Active' : 'On Hold');
  }
  onCandidateToggle(candidate: any): void {
    const activating = !this.isCandidateActive(candidate);
    if (activating && !this.hasAvailableSlot) return;
    this.onCandidateStatusChange(candidate, activating ? 'Available' : 'Unavailable');
  }

  onSlotOptionChange(value: 'INACTIVATE' | 'ASSIGN' | 'UPGRADE') {
    // Re-clicking the open header collapses it; clicking another swaps.
    this.selectedSlotOption = this.selectedSlotOption === value ? null : value;
  }

  // Single-open tracker for the per-row status pill dropdowns. The wrapper's
  // (click)="$event.stopPropagation()" keeps row clicks inert, but it also
  // swallows the outside-click that would close another row's open menu — so
  // several could be open at once. Same [isOpen] pattern as
  // job.component.ts `openStatusPillId` / candidates-page `openStatusId`.
  // Keys are type-prefixed ('J-'/'C-') so a job id can't collide with a
  // candidate id.
  openRowStatusKey: any = null;
  onRowStatusToggle(open: boolean, key: string) {
    this.openRowStatusKey = open
      ? key
      : (this.openRowStatusKey === key ? null : this.openRowStatusKey);
  }

  onSlotSubTypeChange(value: 'JOBS' | 'CANDIDATES') {
    this.slotSubType = value;
    if (value === 'JOBS' && !this.activeListLoaded.JOBS) {
      this.loadActiveJobs();
    } else if (value === 'CANDIDATES' && !this.activeListLoaded.CANDIDATES) {
      this.loadActiveCandidates();
    }
  }

  loadActiveJobs() {
    // Mirrors new-job.component.ts BaseresponseFilter payload for `jobs/filter`.
    // `source.myJobs = true` scopes the list to the current user's jobs.
    const payload: any = {
      source: {
        all: false,
        marketPlaceJobs: false,
        myJobs: true,
        teamJobs: false,
        recruiterNetworkJobs: false,
        freeLancerNetworkJobs: false,
        mtaNetworkJobs: false,
        featured: false,
        suggestedJobs: false
      },
      searchAfterKey: null,
      workMode: [],
      experienceFrom: null,
      experienceTo: null,
      postedFrom: null,
      postedTo: null,
      country: null,
      state: null,
      city: null,
      zipCode: null,
      limit: 100,
      userId: localStorage.getItem('userId') || '',
      jobClassification: [],
      clientType: [],
      status: ['Active'],
      searchContent: '',
      jobsToFilter: null,
      organisationTypeParams: {
        owner: false,
        systemsIntergrator: false,
        vendorStaffingAgency: false,
        primeVendor: false
      },
      personalNetworks: [],
      businessNetworks: [],
      customers: [],
      businessId: localStorage.getItem('businessId') || ''
    };
    this.loadingActiveList = true;
    this.api.create('jobs/filter', payload).subscribe(
      (res: any) => {
        this.loadingActiveList = false;
        this.activeListLoaded.JOBS = true;
        this.activeJobs = res?.data?.jobList || [];
      },
      () => {
        this.loadingActiveList = false;
        this.activeListLoaded.JOBS = true;
        this.activeJobs = [];
      }
    );
  }

  loadActiveCandidates() {
    // Mirrors new-candidate.component.ts payload for `candidates/filter`.
    // `source.myCandidates = true` scopes the list to the current user's candidates.
    const payload: any = {
      source: {
        all: false,
        myCandidates: true,
        marketPlaceCandidates: false,
        teamCandidates: false,
        benchNetworkCandidates: false,
        freeLancerNetworkCandidates: false,
        mtaNetworkCandidates: false,
        jobSeekerNetworkCandidates: false,
        featured: false,
        suggestedCandidates: false
      },
      workMode: [],
      workAuthorization: [],
      engagementType: [],
      availableIn: [],
      status: ['Available'],
      searchAfterKey: null,
      city: null,
      state: null,
      country: null,
      zipCode: null,
      submissionFilters: [],
      postedFrom: null,
      postedTo: null,
      limit: 100,
      userId: localStorage.getItem('userId') || '',
      searchContent: '',
      candidatesToFilter: null,
      businessId: localStorage.getItem('businessId') || ''
    };
    this.loadingActiveList = true;
    this.api.create('candidates/filter', payload).subscribe(
      (res: any) => {
        this.loadingActiveList = false;
        this.activeListLoaded.CANDIDATES = true;
        this.activeCandidates = res?.data?.candidateList || [];
      },
      () => {
        this.loadingActiveList = false;
        this.activeListLoaded.CANDIDATES = true;
        this.activeCandidates = [];
      }
    );
  }

  // The updateJob endpoint expects UPPERCASE status values
  // ('ACTIVE', 'ON HOLD', 'FILLED') — see job-profile-detail.component.ts:704
  // and job.component.ts. Dropdown labels stay title case for display.
  private toApiJobStatus(label: string): string {
    return (label || '').toUpperCase();
  }

  onJobStatusChange(job: any, newStatus: string) {
    const apiStatus = this.toApiJobStatus(newStatus);
    // Optimistic flip: move the slider immediately so it feels instant. Keep
    // the old status so we can roll back if the call fails. Loader blocks
    // interaction while the status update is in flight.
    const previousStatus = job.status;
    job.status = apiStatus;
    const updated = { ...job, status: apiStatus, jobReferenceId: job.jobId };
    this.util.startLoader();
    this.api.updatePut('jobs/updateJob', updated).subscribe(
      (res: any) => {
        this.util.stopLoader();
        if (res?.code === '00000') {
          this.showToast(`Job marked as ${newStatus}`);
          this.refreshSlotCountsUntilChanged();
        } else {
          // API responded but not with success — restore the slider.
          job.status = previousStatus;
        }
      },
      () => {
        // Request failed — restore the slider to its actual state.
        this.util.stopLoader();
        job.status = previousStatus;
      }
    );
  }

  onCandidateStatusChange(candidate: any, newStatus: string) {
    const apiStatus = newStatus === 'Unavailable' ? 'INACTIVE' : 'ACTIVE';
    // Optimistic flip + rollback on failure (see onJobStatusChange).
    const previousStatus = candidate.status;
    candidate.status = apiStatus;
    const updated = { ...candidate, status: apiStatus, candidateReferenceId: candidate.candidateId };
    const formData = new FormData();
    // Never append an empty Blob as the resume. `candidates/filter` returns
    // `resumes` (an array) — there is no `resume` File on these objects, so the
    // old `candidate.resume || new Blob()` fallback fired on EVERY toggle. A
    // bare Blob is sent by the browser as a part named "blob" with 0 bytes and
    // application/octet-stream, which updateCandidate then stored as the
    // candidate's only resume — wiping the real one. `resume` is
    // @RequestPart(required = false), so omitting it leaves resumes untouched.
    if (candidate.resume instanceof Blob && candidate.resume.size > 0) {
      formData.append('resume', candidate.resume);
    }
    formData.append('candidate', new Blob([JSON.stringify(updated)], { type: 'application/json' }));
    this.util.startLoader();
    this.api.updatePut('candidates/updateCandidate', formData).subscribe(
      (res: any) => {
        this.util.stopLoader();
        if (res?.code === '00000') {
          this.showToast(`Candidate marked as ${newStatus}`);
          this.refreshSlotCountsUntilChanged();
        } else {
          candidate.status = previousStatus;
        }
      },
      () => {
        this.util.stopLoader();
        candidate.status = previousStatus;
      }
    );
  }

  private showToast(title: string) {
    Swal.fire({
      position: 'center',
      icon: 'success',
      title,
      showDenyButton: false,
      showConfirmButton: false,
      timer: 2000
    });
  }

  // The backend recomputes JOB_CANDIDATE_POSTINGS usage asynchronously after
  // a job/candidate status change — a single fetch 1.5s later often reads the
  // numbers BEFORE they update, leaving the Allocated/Used/Available header
  // stale. Poll every 1.5s until `utilized` actually moves (or 5 attempts).
  private refreshSlotCountsUntilChanged(): void {
    const before = this.utilizedcredits;
    let attempts = 0;
    const tick = async () => {
      attempts++;
      await this.refreshSlotCounts();
      if (this.utilizedcredits !== before || attempts >= 5) {
        return;
      }
      setTimeout(tick, 1500);
    };
    setTimeout(tick, 1500);
  }

  private async refreshSlotCounts(): Promise<void> {
    try {
      const userId = localStorage.getItem('userId');
      const userDetails: any = await this.api.lamdaFunctionsget(
        'findUserPlanBenefits/' + userId
      );

      if (userDetails?.data?.userPlanAndBenefits?.benefitsUsages) {
        const benefitsUsages = userDetails.data.userPlanAndBenefits.benefitsUsages;
        const slotData = benefitsUsages.find(
          (b: any) => b.benefitKey === 'JOB_CANDIDATE_POSTINGS'
        );

        if (slotData) {
          this.actualcredits = slotData.actual;
          this.utilizedcredits = slotData.utilized;
          this.availablecredits = slotData.available;
          this.promotional = slotData.promotional;
        }
      }
    } catch (error) {
      console.error('Failed to refresh slot counts:', error);
    }
  }

  goToSlotAllocation() {
    this.closeAllForNavigation();
    this.route.navigate(['/user-management/jobs']);
  }

  goToPlanQuota() {
    if (this.onUpgradePlanClick) {
      this.onUpgradePlanClick();
    }
    this.closeAllForNavigation();
    setTimeout(() => {
      this.route.navigate(['/plan-quota']);
    }, 100);
  }

  jobDisplayTitle(job: any): string {
    return job?.jobTitle || job?.title || '(Untitled job)';
  }

  candidateDisplayName(candidate: any): string {
    const first = candidate?.firstName || '';
    const last = candidate?.lastName || '';
    const name = (first + ' ' + last).trim();
    return name || candidate?.fullName || '(Unnamed candidate)';
  }

  showdays: any
 // upgradeform initialization by monisha
  upgradefunction() {

    this.upgradeForm = this.formBuilder.group({
      payasyogo: [''],
      availablesumocredits: [''],
      acceptTerms: [false, Validators.requiredTrue],
      points: [null],
      redeemsumocredits: [this.selectedValue],
      upgradefor: [''],
      limit: ['', [Validators.required]],
      paylimit: ['', [Validators.required]],
      rateperday: [this.CreditConsumePoints],
      price: [null],
    });
    this.upgradeForm.get('availablesumocredits').disable();
    this.upgradeForm.get('points').disable();
    this.upgradeForm.get('upgradefor').disable();
    this.upgradeForm.get('rateperday').disable();
    this.upgradeForm.get('price').disable();

    const price = this.upgradeForm.get('rateperday').value;
    this.upgradeForm.patchValue({ 'availablesumocredits': this.availablecredits })
    this.showdays = this.availablecredits;
    this.upgradeForm.get('limit').valueChanges.subscribe((selectedValue) => {
      if (selectedValue !== undefined) {
        const redeem = selectedValue * 25;
        this.upgradeForm.get('points').patchValue(redeem);
      } else if (selectedValue == undefined) {
        this.upgradeForm.get('points').patchValue(null);
      }
    });
    this.upgradeForm.get('paylimit').valueChanges.subscribe((selectedValue) => {
      if (selectedValue !== undefined) {
        const totalAmount = selectedValue * price;
        const fixedValue = totalAmount.toFixed(2);
        this.upgradeForm.get('price').patchValue(fixedValue);
      } else if (selectedValue == undefined) {
        this.upgradeForm.get('price').patchValue(null);
      }
    });
    if (this.selectedValue == 'redeemsumocredits') {

      this.days = Array.from({ length: this.showdays / 25 }, (_, index) => index + 1);
    }

  }



  days: number[] = Array.from({ length: 30 }, (_, i) => i + 1);
  get isInduvidual(): boolean {
    return this.MemberShipType === "Free" || this.MemberShipType === "Pro";
  }

  userData = {
    userId: localStorage.getItem('userId'),
    userType: localStorage.getItem('userType') || ''
  }


  onItemChange(selectedValue: string) {
    this.selectedValue = selectedValue;
    if (this.selectedValue == 'payasyogo') {
      this.days = Array.from({ length: 30 }, (_, i) => i + 1);
    } else {
      this.days = Array.from({ length: this.showdays / 25 }, (_, index) => index + 1);
    }
    if (this.clearSelectedValues) {
      this.selectedDay = null;
      this.submitted = false;
    }

    return this.selectedValue;
  }

  isPayAsYouGo(val: BENEFITS_KEY): boolean {
    return (val === "ACTIVE_INTERACTIONS" ||
      val === "UPGRADE_CANDIDATES" || val === "UPGRADE_JOBS");
  }

  async getPoints(key: BENEFITS_KEY): Promise<String> {
    try {
      this.util.startLoader();
      let planDetails = await this.pricePlan.getPlan_Features();
      const { subscriptionPlans } = planDetails.data;
      this.util.stopLoader(); 

      if (!subscriptionPlans) {
        console.error('No plans available');
        return null; // or handle appropriately
      }

      if (this.isPayAsYouGo(key)) {
        let ResumeData = subscriptionPlans.find(val => val.subcriptionType === this.MemberShipType);

        if (!ResumeData) {
          console.error(`No matching plan found for membership type: ${this.MemberShipType}`);
          return null; // or handle appropriately
        }

        let upgradeData = subscriptionPlans.find(val => val.order === (ResumeData.order + 1));

        if (upgradeData) {
          this.PlanConsumePoints = upgradeData.monthlySubscriptionAmount;
        }

        if (!ResumeData.payAsYouGoList) {
          console.error('No payAsYouGoList found in current plan');
          return null; // or handle appropriately
        }

        let payAsYouGoItem = ResumeData.payAsYouGoList.find(element => (element.benefitKey as string).includes(key));

        if (!payAsYouGoItem) {
          console.error(`No matching benefit key found in payAsYouGoList for key: ${key}`);
          return null; // or handle appropriately
        }

        return payAsYouGoItem.price;
      } else {
        let data = subscriptionPlans.find(val => val.subcriptionType === this.MemberShipType);

        if (!data) {
          console.error(`No matching plan found for membership type: ${this.MemberShipType}`);
          return null; // or handle appropriately
        }

        let upgradeData = subscriptionPlans.find(val => val.order === (data.order + 1));

        if (upgradeData) {
          this.PlanConsumePoints = upgradeData.monthlySubscriptionAmount;
        }

        return null;
      }
    } catch (error) {
      console.error('An error occurred while fetching points:', error);
      return null; // or handle appropriately
    } finally {
      this.util.stopLoader();
    }
  }
  close() {
    // The × and every Cancel / Close button land here. See closeThisPopup():
    // hide(1) closed whichever modal was OLDEST, not this one.
    this.closeThisPopup();

    this.submitted = false;
    if (this.upgradeForm != undefined) {
      setTimeout(() => {
        this.upgradeForm.reset();
      }, 1000);
    }
  }

  routeToPlan() {
    if (this.onUpgradePlanClick) {
      this.onUpgradePlanClick();
    }
    this.closeAllForNavigation();
    this.route.navigate(['plan-quota']);
  }

  open(content) {
    this.modalRef = this.modalService.show(this.modalPriceTemplate, this.backdropConfig);
  }


  upgradePlan() {
    if (this.onUpgradePlanClick) {
      this.onUpgradePlanClick();
    }
    this.closeAllForNavigation();
    setTimeout(() => {
      this.route.navigate(["plan-quota"]);
    }, 100);
  }

  closemodel() {
    this.dismiss();
  }



  plan(val) {
    this.yearmonth = val

  }
  pricesummary() {
    const userId = localStorage.getItem("userId");
    this.api
      .query("user/findUserPlanBenefits/" + userId)
      .subscribe((res) => {

        console.log("res" + res);

      }, err => {
        this.util.stopLoader();
      });
  }
  sortDate(data) {
    return data.sort((a, b) => {
      return b.isFeatured - a.isFeatured;
    });
  }

  /**
   * Checks if the job/candidate was upgraded via CREDITS today (not via SLOTS)
   * Used to determine if "already paid" message should be shown
   * Only returns true if credits were ACTUALLY charged (credits > 0)
   */
  private wasUpgradedViaCreditToday(item: any, currentDate: Date): boolean {
    if (!item.featuredConsumptions || item.featuredConsumptions.length === 0) {
      return false;
    }

    // Find consumption entries for today
    const todayConsumptions = item.featuredConsumptions.filter(consumption => {
      const consumptionDate = new Date(consumption.fromDate);
      consumptionDate.setHours(0, 0, 0, 0);
      return consumptionDate.getTime() === currentDate.getTime();
    });

    // Check if any of today's consumptions actually charged credits
    // Must have credits > 0 to be considered "paid via credits"
    return todayConsumptions.some(consumption =>
      consumption.credits && consumption.credits > 0
    );
  }
  upgradeCandidate(upgradeDetails) {
    this.FormData = new FormData();
    upgradeDetails.consumptionType = "CREDITS";
    // Only append resume if it's actually being uploaded (not null/empty)
    if (upgradeDetails.resume != null && upgradeDetails.resume !== '') {
      this.FormData.append("resume", upgradeDetails.resume);
    }
    upgradeDetails.candidateReferenceId = upgradeDetails.candidateId;
    this.FormData.append("candidate", new Blob([JSON.stringify(upgradeDetails)], { type: "application/json" }));
    this.util.startLoader()
    this.api.updatePut("candidates/updateCandidate", this.FormData).subscribe((res) => {
      this.util.stopLoader();
      if (res.code == '00000') {

        this.dismiss();
        this.searchData.setfilterReload("reload")
        Swal.fire({
          icon: "success",
          title: "Upgraded Successfully",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,

        });
        this.candidateReload.emit('reload')
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  featurejob(item) {
    item.jobReferenceId = item.jobId;
    item.consumptionType = "CREDITS";
    this.api.updatePut("jobs/updateJob", item).subscribe((res) => {


      if (this.streamRes != null && this.streamRes.code == '00000') {
        this.stremService.clear();
      }
      this.util.stopLoader();
      if (res.code == '00000') {
        this.dismiss();
        Swal.fire({
          icon: "success",
          title: "Job Upgraded",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,
        })
        this.searchData.setfilterReload("reload")

        this.selectedJob.emit(null);
        this.jobReload.emit("reload");

      }
    }, err => {
      this.util.stopLoader();
    });
  }
  generateTitleHtml(action: string, Noofdays: any, pointsOrPrice: any): string {
    const dayText = Noofdays === 1 ? 'day' : 'days';
    return `<div>${action} for ${Noofdays} ${dayText} will consume ${pointsOrPrice} credits</div>`;
  }

  updatedDate: string;
  //common function for upgrading jobs and candidates by monisha
  upgradejobandcandidatedetails(upgradeDetails, param, currentdate, featureddate, alertdate) {
    if (param == "") {
      currentdate = this.currentdate;
      featureddate = this.featureddate;
      alertdate = this.alertdate;
    }

    let titleHtml = '';
    let secondtitle = '';
    let action = '';

    if (this.ModelContent && this.ModelContent.headerName === 'Upgrade Candidate') {
      action = 'Upgrading a candidate';
    } else if (this.ModelContent && this.ModelContent.headerName === 'Upgrade Job') {
      action = 'Upgrading a Job';
    }

    if (this.selectedValue === 'redeemsumocredits' || this.selectedValue === 'payasyogo') {
      const pointsOrPrice =
        this.selectedValue === 'redeemsumocredits'
          ? this.upgradeForm.get('points').value
          : this.upgradeForm.get('price').value;
      const noOfDays =
        this.selectedValue === 'redeemsumocredits'
          ? this.upgradeForm.get('limit').value
          : this.upgradeForm.get('paylimit').value;
      titleHtml = this.generateTitleHtml(action, noOfDays, pointsOrPrice);
    }

    if (upgradeDetails.isFeatured === false && param === 'Upgrade Candidate') {
      secondtitle =
        'You will not be charged for this Candidate again for the day as it has already been paid for.';
    } else if (upgradeDetails.isFeatured === false && param === 'Upgrade Job') {
      secondtitle =
        'You will not be charged for this job again for the day as it has already been paid for.';
    }

    if (param === "") {
      if (
        (upgradeDetails.isFeatured !== false &&
          this.ModelContent.headerName === 'Upgrade Candidate') ||
        (upgradeDetails.isFeatured === false &&
          this.ModelContent.headerName === 'Upgrade Candidate' &&
          currentdate > featureddate)
      ) {
        this.dynamicMessage =
          'Once upgraded, this candidate will be shown under the featured category and can be seen beyond your connections. Would you like to upgrade the candidate?';
      } else if (
        (upgradeDetails.isFeatured !== false &&
          this.ModelContent.headerName === 'Upgrade Job') ||
        (upgradeDetails.isFeatured === false &&
          this.ModelContent.headerName === 'Upgrade Job' &&
          currentdate > featureddate)
      ) {
        this.dynamicMessage =
          'Once upgraded, this job will be shown under the featured category and can be seen beyond your connections.  Would you like to upgrade the job?';
      }
    }

    // Check if same day upgrade
    const isSameDay = currentdate && featureddate && !isNaN(featureddate.getTime()) && currentdate.getTime() === featureddate.getTime();

    // Only set price=0, points=0 if:
    // 1. Job/Candidate is currently featured (isFeatured == true), OR
    // 2. Same day AND previous upgrade was via CREDITS (already paid)
    if (upgradeDetails.isFeatured == true || (isSameDay && this.wasUpgradedViaCreditToday(upgradeDetails, currentdate))) {
      upgradeDetails.price = 0;
      upgradeDetails.points = 0;
    } else if (currentdate > featureddate && upgradeDetails.isFeatured == false || upgradeDetails.isFeatured == null || upgradeDetails.isFeatured == undefined || (upgradeDetails.isFeatured == false && !this.wasUpgradedViaCreditToday(upgradeDetails, currentdate))) {
      // Set price/points from form for:
      // 1. Different day re-upgrade
      // 2. First time upgrade (null/undefined)
      // 3. Same day SLOT upgrade (need to charge credits)
      if (this.upgradeForm != undefined) {
        upgradeDetails.price = this.upgradeForm.getRawValue().price;
        upgradeDetails.points = this.upgradeForm.getRawValue().points;
      }
    }

    // Day end upgrade validation
    if (alertdate.getHours() >= 18 && this.upgradeForm&&this.upgradeForm.get('limit').value == 1&&(currentdate > featureddate && upgradeDetails.isFeatured == false|| upgradeDetails.isFeatured == null || upgradeDetails.isFeatured == undefined || (upgradeDetails.isFeatured == false && !this.wasUpgradedViaCreditToday(upgradeDetails, currentdate)))) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "The day is about to end.",
          text: "Are you sure you want to upgrade until EOD?",
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.processupgrade(
              upgradeDetails,
              param,
              currentdate,
              featureddate,
              titleHtml,
              secondtitle
            );
          }
        });
    } else {
      this.processupgrade(
        upgradeDetails,
        param,
        currentdate,
        featureddate,
        titleHtml,
        secondtitle
      );
    }
  }

  processupgrade(
    upgradeDetails,
    param,
    currentdate,
    featureddate,
    titleHtml,
    secondtitle
  ) {
    // `== null` matches both `undefined` and `null`. The backend ships
    // `isFeatured: null` (not undefined) for candidates / jobs that have
    // never been featured, so a strict `=== undefined` check let the
    // first-time-upgrade case fall through to the silent exit at the
    // bottom of the function and the Redeem button made no API call.
    if (
      upgradeDetails.isFeatured == null ||
      (currentdate > featureddate && upgradeDetails.isFeatured === false)
    ) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: titleHtml,
          text: this.dynamicMessage,
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed && this.ModelContent.headerName == 'Upgrade Job') {
            upgradeDetails.isFeatured = true;
            upgradeDetails.limit = this.upgradeForm.get('limit').value;
            if (upgradeDetails.limit == undefined) {
              upgradeDetails.limit = this.upgradeForm.get('paylimit').value;
            }
            this.featurejob(upgradeDetails);
          } else if (result.isConfirmed && this.ModelContent.headerName == 'Upgrade Candidate') {
            upgradeDetails.isFeatured = true;
            upgradeDetails.limit = this.upgradeForm.get('limit').value;
            if (upgradeDetails.limit == undefined) {
              upgradeDetails.limit = this.upgradeForm.get('paylimit').value;
            }
            this.upgradeCandidate(upgradeDetails)
          }
        });
    } else if (upgradeDetails.isFeatured === false) {
      // Check if previously upgraded via CREDITS today
      if (this.wasUpgradedViaCreditToday(upgradeDetails, currentdate)) {
        // Previous upgrade was via CREDITS - show "already paid" message
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons
          .fire({
            title: secondtitle,
            text: this.dynamicMessage,
            icon: "warning",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Ok',
            cancelButtonText: 'No',
            reverseButtons: true,
          })
          .then((result) => {
            // `param` is empty when called from `redeemthecredits`
            // (line 677) — the original `param == 'Upgrade Job' /
            // 'Upgrade Candidate'` checks never matched and the API
            // call was silently skipped. `this.ModelContent.headerName`
            // is the actual source of truth, same as CASE 1 and CASE 2b.
            if (result.isConfirmed && this.ModelContent.headerName == 'Upgrade Job') {
              upgradeDetails.isFeatured = true;
              this.upgradefunction();
              upgradeDetails.limit = this.upgradeForm.get('limit').value;
              if (upgradeDetails.limit == undefined) {
                upgradeDetails.limit = this.upgradeForm.get('paylimit').value;
              }
            this.featurejob(upgradeDetails);
          } else if (result.isConfirmed && this.ModelContent.headerName == 'Upgrade Candidate') {
            upgradeDetails.isFeatured = true;
            this.upgradefunction();
            upgradeDetails.limit = this.upgradeForm.get('limit').value;
            if (upgradeDetails.limit == undefined) {
              upgradeDetails.limit = this.upgradeForm.get('paylimit').value;
            }
            this.upgradeCandidate(upgradeDetails)
          }
        });
      } else {
        // Previous upgrade was via SLOTS (not CREDITS) - proceed with normal upgrade
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons
          .fire({
            title: titleHtml,
            text: this.dynamicMessage,
            icon: "warning",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed && this.ModelContent.headerName == 'Upgrade Job') {
              upgradeDetails.isFeatured = true;
              upgradeDetails.limit = this.upgradeForm.get('limit').value;
              if (upgradeDetails.limit == undefined) {
                upgradeDetails.limit = this.upgradeForm.get('paylimit').value;
              }
              this.featurejob(upgradeDetails);
            } else if (result.isConfirmed && this.ModelContent.headerName == 'Upgrade Candidate') {
              upgradeDetails.isFeatured = true;
              upgradeDetails.limit = this.upgradeForm.get('limit').value;
              if (upgradeDetails.limit == undefined) {
                upgradeDetails.limit = this.upgradeForm.get('paylimit').value;
              }
              this.upgradeCandidate(upgradeDetails)
            }
          });
      }
    }
  }

  redeemthecredits(upgradeDetails) {
    this.submitted = true;
    if (this.selectedValue == 'redeemsumocredits') {
      this.upgradeForm.get('paylimit').clearValidators();
      this.upgradeForm.get('paylimit').updateValueAndValidity();
    } else if (this.selectedValue == 'payasyogo') {
      this.upgradeForm.get('limit').clearValidators();
      this.upgradeForm.get('limit').updateValueAndValidity();
    }
    if (this.selectedValue == 'redeemsumocredits' && this.upgradeForm.value.acceptTerms && this.upgradeForm.valid && this.upgradeForm.get('points').value != 0) {
      this.upgradejobandcandidatedetails(upgradeDetails, '', '', '', '');
    } else if (this.selectedValue == 'payasyogo' && this.upgradeForm.value.acceptTerms && this.upgradeForm.valid && this.upgradeForm.get('price').value != 0.00) {
      this.upgradejobandcandidatedetails(upgradeDetails, '', '', '', '');
    }

  }

  showManage() : boolean {
    const URl = window.location.hash.split('?')[0];
    const onManageBusiness = URl === "#/user-management/businessContacts/managebusiness";
    const onManageMembers = URl === "#/user-management/contacts/contactDetails";
    return (this.content === "B2B_CONTACTS" && !onManageBusiness) || (this.content === "INCLUDED_CONVERSATIONS" && !onManageMembers);
  }

  routeTo(){
    // Only these two content types actually navigate; for anything else this is a
    // plain close and whatever sits underneath must survive.
    if (this.content === "B2B_CONTACTS" || this.content === "INCLUDED_CONVERSATIONS") {
      this.closeAllForNavigation();
    } else {
      this.close();
    }
    setTimeout(() => {
      if(this.content === "B2B_CONTACTS"){
        this.router.navigate(["/user-management/businessContacts/managebusiness"]);
      }
      else if(this.content === "INCLUDED_CONVERSATIONS"){
        this.router.navigate(["/user-management/contacts/contactDetails"]);
      }
    }, 1000);
  }

  getButtonName() {
    return this.content === "B2B_CONTACTS" ? "Manage Business" : "Manage Members"
  }


}

